import type { PhoneMenuSelection } from '@src/service/voice/ActiveCall'
import Badge from '@ui/Badge'
import Tooltip from '@ui/Tooltip'
import { PhoneMenuIcon } from '@ui/icons/standard'

interface IncomingCallPhoneMenuBadgeProps {
  phoneMenuSelection: PhoneMenuSelection
}

function IncomingCallPhoneMenuBadge({
  phoneMenuSelection,
}: IncomingCallPhoneMenuBadgeProps) {
  return (
    <Tooltip title={`Phone menu option ${phoneMenuSelection}`} colorScheme="call">
      <div aria-label={`Selected phone menu option ${phoneMenuSelection}`}>
        <Badge
          color="purple"
          icon={<PhoneMenuIcon />}
          label={phoneMenuSelection}
          variant="rounded"
        />
      </div>
    </Tooltip>
  )
}

export default IncomingCallPhoneMenuBadge
